module.exports = __webpack_public_path__ + "img/logo_knowage.00499215.svg";